module.exports = __webpack_public_path__ + "img/padlock-unlocked.a1fcef89.svg";